import { render, staticRenderFns } from "./verticalNavMenuBalance.vue?vue&type=template&id=068a256e&"
import script from "./verticalNavMenuBalance.vue?vue&type=script&lang=js&"
export * from "./verticalNavMenuBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports